import {
    FETCH_NOTIFICATIONS_REQUEST,
      FETCH_NOTIFICATIONS_SUCCESS,
      FETCH_NOTIFICATIONS_FAILURE,
    } from "./FetchNotificationsTypes";
    import api from "../../utils/Api";
    
    export const fetchNotificationsRequest = () => {
      return {
        type: FETCH_NOTIFICATIONS_REQUEST,
      };
    };
    
    export const fetchNotificationsSuccess = (notifications) => {
      return {
        type: FETCH_NOTIFICATIONS_SUCCESS,
        payload: notifications,
      };
    };
    
    export const fetchNotificationsFailure = (error) => {
      return {
        type: FETCH_NOTIFICATIONS_FAILURE,
        payload: error,
      };
    };
    
    export const fetchNotificationsListing = (page) => {
      
      const headers = {
        Authorization:
          "Bearer " + JSON.parse(localStorage.getItem("USER_INFO")).token,
      };
      let url = "notification";
        if(page){
            url+="?page="+page;
        }
        
      return async (dispatch) => {
        dispatch(fetchNotificationsRequest);
        try {
          const response = await api.get(url,
            {
              headers: headers,
            }
          );
          const notifications = response.data.data;
          dispatch(fetchNotificationsSuccess(notifications));
        } catch (error) {
          console.log("Redux error - ", error.response);
          const errorMsg = error.message;
          dispatch(fetchNotificationsFailure(errorMsg));
        }
      };
    };
    